import { CALL_API } from '../middleware/ApiMiddleware';

export const CONFIG_PAYMENT_GATEWAY_INTEGRATION_FETCH_REQUEST = 'CONFIG_PAYMENT_GATEWAY_INTEGRATION_FETCH_REQUEST';
export const CONFIG_PAYMENT_GATEWAY_INTEGRATION_FETCH_SUCCESS = 'CONFIG_PAYMENT_GATEWAY_INTEGRATION_FETCH_SUCCESS';
export const CONFIG_PAYMENT_GATEWAY_INTEGRATION_FETCH_FAILURE = 'CONFIG_PAYMENT_GATEWAY_INTEGRATION_FETCH_FAILURE';

export const fetchConfigPaymentGatewayIntegration = () => ({
  [CALL_API]: {
    endpoint: `config/payment-integration`,
    method: 'get',
    authenticated: true,
    types: [
      CONFIG_PAYMENT_GATEWAY_INTEGRATION_FETCH_REQUEST,
      CONFIG_PAYMENT_GATEWAY_INTEGRATION_FETCH_SUCCESS,
      CONFIG_PAYMENT_GATEWAY_INTEGRATION_FETCH_FAILURE,
    ],
  },
});
